module.exports = __webpack_public_path__ + "media/images/contents-323a8d9b0d87c45342ef86b81f7e5e54.png";